module.exports = __webpack_public_path__ + "assets/blog1.40b77b1a.jpg";